export default __webpack_public_path__ + "static/media/stargrills_logo.71bc3964.png";